// Centralised data-testid values for reliable UI testing.
export const NAV = {
  logo: "nav-logo",
  home: "nav-link-home",
  about: "nav-link-about",
  services: "nav-link-services",
  verticals: "nav-link-verticals",
  blog: "nav-link-blog",
  support: "nav-link-support",
  contact: "nav-link-contact",
  mobileToggle: "nav-mobile-toggle",
  ctaStart: "nav-cta-start-project",
};

export const HOME = {
  hero: "home-hero",
  heroCtaStart: "hero-cta-start-project",
  heroCtaContact: "hero-cta-contact",
  whyChoose: "home-why-choose",
  servicesOverview: "home-services-overview",
  serviceCard: (slug) => `home-service-card-${slug}`,
  howWeWork: "home-how-we-work",
  industries: "home-industries",
  aiSupportEntry: "home-ai-support-entry",
  finalCta: "home-final-cta",
  finalCtaButton: "home-final-cta-button",
};

export const SERVICES = {
  root: "services-page",
  card: (slug) => `service-card-${slug}`,
  cardCta: (slug) => `service-card-cta-${slug}`,
};

export const ABOUT = {
  root: "about-page",
};

export const SUPPORT = {
  root: "support-page",
  searchInput: "support-search-input",
  askButton: "support-ask-button",
  answer: "support-answer",
  quickPrompt: (slug) => `support-quick-prompt-${slug}`,
  fallbackContact: "support-fallback-contact",
};

export const CONTACT = {
  root: "contact-page",
  name: "contact-input-name",
  email: "contact-input-email",
  company: "contact-input-company",
  topic: "contact-input-topic",
  message: "contact-input-message",
  submit: "contact-submit-button",
  success: "contact-success-message",
  channelEmail: "contact-channel-email",
  channelWhatsapp: "contact-channel-whatsapp",
  channelLinkedin: "contact-channel-linkedin",
};

export const FOOTER = {
  root: "site-footer",
};
